import JoinUs from '../assets/join-us.png';
import JoinUsMedium from '../assets/join-us-medium.png';

function SectionSeven() {
  return (
    <section className="py-6 px-4 md:px-6 md:py-8">
      <picture>
        <source media="(min-width: 768px)" srcSet={JoinUsMedium} />
        <img src={JoinUs} alt="" className="w-full" />
      </picture>
    </section>
  );
}

export default SectionSeven;
